import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  EIremboFormlyFieldTypes,
  alphaNanoIdUtil,
} from '@irembo-andela/irembogov3-common';

export const buildSlotWidgetField = (label: string): FormlyFieldConfig => {
  const fieldKey = alphaNanoIdUtil(5);

  const slotBookingField: FormlyFieldConfig = {
    key: `slotbooking${fieldKey}`,
    type: EIremboFormlyFieldTypes.customslotbooking,
    props: {
      label: `${label}`,
      scheduleId: null,
      configs: [
        {
          key: `groupType${fieldKey}`,
          label: 'Group Type',
          required: true,
          bindlabel: 'name',
          bindvalue: '',
          placeholder: 'Select Group Type',
          requiredErrorMessage: 'This field is required',
        },
        {
          key: `group${fieldKey}`,
          label: 'Group',
          parent: `groupType${fieldKey}`,
          required: true,
          bindlabel: 'name',
          bindvalue: '',
          placeholder: 'Select Group',
          requiredErrorMessage: 'This field is required',
        },
        {
          key: `timeRange${fieldKey}`,
          label: 'Time',
          parent: `group${fieldKey}`,
          required: true,
          bindlabel: 'name',
          bindvalue: '',
          placeholder: 'Select Time Range',
          requiredErrorMessage: 'This field is required',
        },
        {
          key: `seats${fieldKey}`,
          label: 'Seat',
          parent: `timeRange${fieldKey}`,
          isSeats: true,
          required: true,
          placeholder: 'Provide seats',
          maxSeatErrorMessage: 'Maximum seats exceeded',
          minSeatErrorMessage: 'Invalid seat numner',
          numbersOnlyErrorMessage: 'Numbers only',
          requiredErrorMessage: 'This field is required',
        },
      ],
    },
    validation: {
      messages: {
        invalidSlot: 'Invalid slot',
      },
    },
  };

  return slotBookingField;
};
